import { Accordion, AccordionItem } from "@szhsin/react-accordion";
import { LargePlusIcon, MinusIcon } from "assets/icons";
import cn from "classnames";
import { If } from "components";
import { useSearchParams } from "react-router-dom";
import { Icon, RadioButton } from "ui";

import { CategoryItemAccordionProps } from "./CategoryItemAccordion.types";

import styles from "./CategoryItemAccordion.module.scss";

const CategoryItemAccordion = ({
  category,
  isCategorySelected,
  onSelect,
  nestingLevel = 0,
  disabled: _disabled = false,
  ...rest
}: CategoryItemAccordionProps) => {
  const [searchParams] = useSearchParams();
  return (
    <AccordionItem
      initialEntered={isCategorySelected}
      {...rest}
      header={({ state: { isEnter } }) => (
        <div
          className={styles.header}
          style={{ paddingLeft: 20 * nestingLevel }}
        >
          <RadioButton
            readOnly
            checked={isCategorySelected}
            label={category.name}
            onClick={(e) => {
              if (isEnter) {
                e.stopPropagation();
              }
              onSelect(category);
            }}
          />

          <If condition={category.childCategories}>
            <Icon
              as={isEnter ? MinusIcon : LargePlusIcon}
              boxSize={16}
              className={cn(styles.header_enteredIndicator)}
            />
          </If>
        </div>
      )}
      buttonProps={{
        className: styles.accordion_headerButton
      }}
      panelProps={{ className: styles.accordion_panel }}
    >
      <If condition={category.childCategories}>
        <Accordion>
          {category.childCategories?.map((childCategory) => (
            <CategoryItemAccordion
              key={childCategory.id}
              category={childCategory}
              isCategorySelected={
                searchParams.get(childCategory.type) === childCategory.id
              }
              onSelect={onSelect}
              nestingLevel={nestingLevel + 1}
            />
          ))}
        </Accordion>
      </If>
    </AccordionItem>
  );
};

export default CategoryItemAccordion;
